import {
  FETCH_EMP_ALLOCATION_REQUEST,
  FETCH_EMP_ALLOCATION_SUCCESS,
  FETCH_EMP_ALLOCATION_FAILURE,
} from "../constants/EmpAllocationConstants";

import EmpAllocationService from "../service/EmpAllocationService";

export const fetchEmpAllocation = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMP_ALLOCATION_REQUEST });
    
    const data = await EmpAllocationService.getAll(date);

    dispatch({
      type: FETCH_EMP_ALLOCATION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMP_ALLOCATION_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
